import {postThumbnailFitTypes} from 'features/postGenerator/typescript';

const handlePostThumbnailFitTypes = (post_thumbnail_fit_type: 'AUTO' | 'CONTAIN' | 'COVER') => {
  const thumbnailType = {
    AUTO: postThumbnailFitTypes.auto,
    COVER: postThumbnailFitTypes.cover,
    CONTAIN: postThumbnailFitTypes.contain,
  };

  return thumbnailType[post_thumbnail_fit_type];
};
export default handlePostThumbnailFitTypes;
